exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".menu-item[data-v-1a7978dc]{height:64px;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:16px;color:#666}.menu-item .nameWrap[data-v-1a7978dc]{width:80px;height:30px;border-radius:4px;text-align:center;line-height:30px;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.menu-item.unvalid[data-v-1a7978dc]{cursor:not-allowed}.menu-item.unvalid .nameWrap[data-v-1a7978dc]{color:#999}\n", ""]);

// exports
